class ResetStatus {
    static SUPPORT = 1;
    static REJECT = 2;
    static APPROVAL = 3;
    static WAIT_RESET = 4;
  }
  
  export default ResetStatus;
  